import * as React from 'react'
import Svg from '@eversports/klimt-primitives/Svg'

import SearchIcon from '../assets/search.svg'

const SearchSvg = ({ size }: { size: number }) => <Svg src={SearchIcon} width={size} height={size} color="midnight" />

export default SearchSvg
